import { Trans } from '@lingui/react';
import type { InlineProductCardProduct } from '@we-make-websites/ui-lib/components';
import { RecommendedEssentialCardDesktop } from '@we-make-websites/ui-lib/src';
import clsx from 'clsx';
import { MediaMatch } from 'components/mediaMatch/MediaMatch';
import { InlineProductCardConnected } from 'components/productCard/InlineProductCardConnected';
import { useProduct } from 'components/productContext/ProductProvider';
import { RecommendedEssentialsModal } from 'components/recommendedEssentials/RecommendedEssentialsModal';

import styles from './RecommendedEssentials.module.scss';

/**
 * RecommendedEssentials Component.
 * Product up sells.
 */
export const RecommendedEssentials = () => {
  const productContext = useProduct();
  if (productContext === undefined)
    throw new Error(
      'RecommendedEssentials must be used within a ProductContext'
    );

  const { recommendedEssentials } = productContext;

  if (!recommendedEssentials.length) return null;

  return (
    <div className={styles.recommendedEssentials}>
      <MediaMatch query="(max-width: 1024px)">
        <RecommendedEssentialsModal products={recommendedEssentials} />
      </MediaMatch>

      <div className={styles.recommendedEssentials__listWrapper}>
        <p
          className={clsx(
            styles.recommendedEssentials__title,
            'text-body-1-bold-mobile text-body-1-bold-desktop'
          )}
        >
          <Trans id="recommendedEssentials" message="Recommended Essentials" />
        </p>
        <RecommendedEssentialsList products={recommendedEssentials} />
      </div>
    </div>
  );
};

const RecommendedEssentialsList = ({
  products,
}: {
  products: InlineProductCardProduct[];
}) => {
  return (
    <fieldset>
      <legend className="visually-hidden">
        <Trans id="recommendedEssentials.upSellsLegend">
          Need any of these?
        </Trans>
      </legend>
      <div className={styles.recommendedEssentials__list}>
        {products.map((product, productIndex) => {
          if (!product) return null;

          return (
            <div
              key={productIndex}
              className={styles.recommendedEssentials__cardWrapper}
            >
              <InlineProductCardConnected
                productCardComponent={RecommendedEssentialCardDesktop}
                product={{ ...product, systemName: '' }}
              />
            </div>
          );
        })}
      </div>
    </fieldset>
  );
};
